import { IllegalArgumentError } from "@archipad-js/core/error";
import { RemarkAnnotationGeneratedEntity } from "./generated/RemarkAnnotationGeneratedEntity";
import { RemarkEntity } from "./RemarkEntity";

export abstract class RemarkAnnotationEntity extends RemarkAnnotationGeneratedEntity {
    public get parentAnnotatedEntity(): RemarkEntity {
        return this.remark;
    }

    public set parentAnnotatedEntity(parentAnnotatedEntity: RemarkEntity) {
        if (!parentAnnotatedEntity) {
            throw new IllegalArgumentError("cannot be null nor undefined", "parentAnnotatedEntity");
        }
        this.remark = parentAnnotatedEntity;
    }
}
